<template>
  <CreateEditUserModal
    v-if="showCreateEditUserModal"
    :userId="userIdSelected"
    @closeModal="closeModal"
  />
  <DeleteUserModal
    v-if="showDeleteUserModal"
    :userId="userIdSelected"
    @closeModal="closeModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Usuários</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Você pode ter até
        <strong>{{ numUsers.numUsersAllowed }} usuários</strong> ativos.
        Atualmente, há
        <strong>{{ numUsers.numUsersActive }} usuários</strong> ativos.
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-dark"
          title="Cadastrar Usuário"
          @click="createEditUser()"
        >
          Cadastrar Usuário
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListUsers
      v-else
      :users="users"
      @createEditUser="createEditUser"
      @deleteUser="deleteUser"
    />
  </div>
</template>

<script>
import CreateEditUserModal from '@/components/company/users/CreateEditUserModal.vue'
import DeleteUserModal from '@/components/company/users/DeleteUserModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListUsers from '@/components/company/users/ListUsers.vue'

export default {
  name: 'Users',

  components: {
    CreateEditUserModal,
    DeleteUserModal,
    LoadingData,
    ListUsers,
  },

  data() {
    return {
      isLoadingData: true,
      numUsers: {
        numUsersAllowed: 0,
        numUsersActive: 0,
      },
      users: [],
      showCreateEditUserModal: false,
      showDeleteUserModal: false,
      userIdSelected: null,
    }
  },

  methods: {
    async getUsers() {
      try {
        this.numUsers = await this.$store.dispatch('getNumUsers')
        this.users = await this.$store.dispatch('getUsers')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditUser(userId) {
      this.userIdSelected = userId || null
      this.showCreateEditUserModal = true
    },

    deleteUser(userId) {
      this.userIdSelected = userId
      this.showDeleteUserModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.getUsers()
      }
      this.showCreateEditUserModal = false
      this.showDeleteUserModal = false
    },
  },

  mounted() {
    this.getUsers()
  },
}
</script>
